'use strict';

import Constants from '../constants';
import { detailsMaker as ResultsMaker } from '../../../../helpers/reducer';

export default ResultsMaker(Constants.GET_TOS_DETAILS,  Constants.GET_TOS_DETAILS_RESPONSE,
    'UNUSED', 'UNUSED',
    'UNUSED', 'UNUSED',
    {
        id: undefined, title: undefined, sub_title: undefined, terms: undefined
    });
